// Globale Gast-Einstellungsseite — weder task- noch projektbezogen.
//
// Erreichbar für JEDEN externen Gast mit aktiver Einladung (task- ODER
// projekt-skopiert): MCP-Connect + E-Mail-Benachrichtigungs-Toggle an einem
// festen, immer erreichbaren Ort (Link aus GuestTaskView.tsx-Header und aus
// dem Gast-Chrome in Layout.tsx), statt in eine Aufgaben- oder Projektseite
// eingebettet zu sein.
//
// Routing-Guard: lädt /api/external/me. Kein aktiver Gast (401/kein Invite)
// → Redirect nach /login.

import { useEffect, useState } from "preact/hooks";
import { useLocation } from "wouter-preact";
import { ArrowLeft } from "lucide-preact";
import { api } from "../lib/api";
import { GuestConnectPanel } from "../components/GuestConnectPanel";

interface GuestMe {
  task_id: number | null;
  project_id: number | null;
}

export function GuestSettings(): preact.JSX.Element {
  const [, setLocation] = useLocation();
  const [me, setMe] = useState<GuestMe | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const result = await api<GuestMe>("/api/external/me", { silent401: true });
        if (cancelled) return;
        setMe(result);
        setLoading(false);
      } catch {
        if (cancelled) return;
        setLocation("/login");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading || !me) {
    return (
      <main class="min-h-dvh flex items-center justify-center p-6 bg-[color:var(--color-surface)]">
        <p class="text-sm text-[color:var(--color-on-surface-variant)]">Lädt…</p>
      </main>
    );
  }

  const backHref = me.task_id != null ? "/guest-task" : "/dashboard";

  return (
    <main class="min-h-dvh bg-[color:var(--color-surface)] py-8 px-4">
      <div class="mx-auto max-w-2xl">
        <header class="mb-6 flex items-center gap-3">
          <a
            href={backHref}
            class="inline-flex items-center gap-1 rounded p-1.5 text-[color:var(--color-on-surface-variant)] hover:bg-[color:var(--color-surface-container-low)] hover:text-[color:var(--color-on-surface)]"
            aria-label="Zurück"
          >
            <ArrowLeft size={20} aria-hidden="true" />
          </a>
          <h1 class="text-lg font-bold text-[color:var(--color-on-surface)]">
            Einstellungen
          </h1>
        </header>

        <GuestConnectPanel defaultOpen collapsible={false} />
      </div>
    </main>
  );
}
